import constants from '@/constants';
import { axiosRequest, METHOD } from '@/api/default.js';

export async function getUserAnalytics(params) {
    return await axiosRequest({
        url: constants.URL.USER_ANALYTICS,
        method: METHOD.GET,
        requestName: 'GET USER ANALYTICS',
        params,
        isLoader: false,
    });
}

export async function refreshUserAnalytics() {
    return await axiosRequest({
        url: constants.URL.USER_ANALYTICS_REFRESH,
        method: METHOD.POST,
        requestName: 'REFRESH USER ANALYTICS',
        isLoader: false,
    });
}

export async function getRefreshStatus() {
    return await axiosRequest({
        url: constants.URL.USER_ANALYTICS_REFRESH_STATUS,
        method: METHOD.GET,
        requestName: 'GET REFRESH STATUS',
        isLoader: false,
    });
}

export async function exportUserAnalytics(params) {
    return await axiosRequest({
        url: constants.URL.USER_ANALYTICS_EXPORT,
        method: METHOD.GET,
        requestName: 'EXPORT USER ANALYTICS',
        params,
        isLoader: false,
        responseType: 'blob',
        returnFullResponse: true,
    });
}
